<script setup lang="ts">
import GasMeterReading from '@/components/GasMeterReading.vue'
</script>

<template>
  <main>
    <GasMeterReading />
  </main>
</template>

<style scoped>
</style>
